import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-gif",
  "use": "icon-gif-usage",
  "viewBox": "0 0 21 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 24\" id=\"icon-gif\"><path d=\"M19.67,8.58H19.1V5.8a.41.41,0,0,0,0-.05A.46.46,0,0,0,19,5.45L14.41.16h0L14.32.08l0,0L14.2,0H2.83A.94.94,0,0,0,1.9.94V8.58H1.33A1.34,1.34,0,0,0,0,9.93H0v7a1.34,1.34,0,0,0,1.33,1.35H1.9v4.79a.94.94,0,0,0,.93.94H18.17a.94.94,0,0,0,.93-.94V18.27h.57A1.34,1.34,0,0,0,21,16.93v-7a1.34,1.34,0,0,0-1.33-1.35ZM18.17,22.8H2.83V18.27H18.17ZM7,15.82a2.16,2.16,0,0,0,.77-.1V14.24H6.69V13H9.28v3.7A7.69,7.69,0,0,1,7,17.1a3.84,3.84,0,0,1-2.82-.95,3.42,3.42,0,0,1-1-2.55c0-2.34,1.69-3.67,4-3.67a4.73,4.73,0,0,1,1.93.34l-.33,1.27a3.81,3.81,0,0,0-1.62-.3,2.11,2.11,0,0,0-2.3,2.27A2.1,2.1,0,0,0,7,15.82ZM10.5,17V10h1.58v7Zm7-4.12V14.2H15V17H13.44V10h4.24v1.3H15v1.61h2.5Zm.66-4.32H2.83V.94H13.6V5.76a.47.47,0,0,0,.46.47h4.11Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/gif.svg
// module id = 134
// module chunks = 0 1 2